export default {
  title: 'FightCamp Logo Hoodie - Oatmeal',
  id: 'fightcamp_logo_hoodie_oatmeal',
  price: 6500,
  category: 'accessory',
  description: 'Elevate your training style with our Oatmeal FightCamp Logo Hoodie. This lightweight unisex sweatshirt boasts a kangaroo pocket, drawcords, and a cozy blend of 65% cotton and 35% polyester.',
  img_url: 'https://a.storyblok.com/f/152150/400x400/7c3e7b251c/preview-fc-logo-hoodie-oatmeal-001.jpg',
  fbid: '',
  marketplace_img_url: '',
  types: ['Apparel']
};